const ns = "MODULES_LAYOUT_STARRED_FIELDS";
export const SHOW = `${ns}_SHOW`;
export const HIDE = `${ns}_HIDE`;
export const UPDATE = `${ns}_UPDATE`;
